<template>
  <BasePanelWithHeader headerText="Sessions">
    <BaseSimpleDataTable
      :headers="filteredHeaders"
      :items="filteredLuSessions"
      :loading="loading"
      search
      sort-by="Year"
      sort-desc
    >
      <template v-slot:prependParams>
        <v-col cols="12" sm="auto">
          <v-switch v-model="showInactive" label="Show Inactive"></v-switch>
        </v-col>
      </template>
      <template v-slot:appendParams>
        <v-col cols="12" sm="auto" class="mt-4 mr-4">
          <BaseTooltipButton
            small
            @click="$refs.luSessionForm.addLuSession()"
            icon="mdi-plus"
            iconColor="white"
            buttonClass="primary"
            >Add Session
          </BaseTooltipButton>
        </v-col>
      </template>
      <template v-slot:item.edit="{ item }">
        <BaseTooltipButton
          small
          @click="$refs.luSessionForm.editLuSession(item)"
          iconColor="primary"
          icon="mdi-pencil"
          >Edit Session
        </BaseTooltipButton>
      </template>
      <template v-slot:item.delete="{ item }">
        <BaseTooltipButton
          small
          @click="$refs.luSessionDelete.deleteConfirm(item)"
          iconColor="primary"
          icon="mdi-delete"
          >Delete Session
        </BaseTooltipButton>
      </template>
    </BaseSimpleDataTable>
    <BaseDeleteConfirm
      ref="luSessionDelete"
      :delete="deleteLuSession"
      @refresh="clearLookupCacheAndReloadLuSessions"
    >
      Are you sure you want to delete this session?
    </BaseDeleteConfirm>
    <LuSessionDialogForm
      ref="luSessionForm"
      @refresh="clearLookupCacheAndReloadLuSessions"
    >
    </LuSessionDialogForm>
  </BasePanelWithHeader>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuSessionDialogForm from '@components/form/add-edit/LuSessionDialog'
// site.min.js from wyoleg.gov
// YEAR_VALUES
export default {
  components: {
    LuSessionDialogForm,
  },
  data: () => ({
    showInactive: false,
  }),
  created() {
    this.loadLuSessions()
  },
  computed: {
    ...get('luSession', ['luSessions', 'loading']),
    filteredLuSessions() {
      var list = this.luSessions.filter((i) => true)
      if (!this.showInactive) {
        list = list.filter((i) => i.IsActive)
      }
      return list
    },
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'Id',
          visible: false,
        },
        {
          text: 'Year',
          align: 'center',
          sortable: true,
          value: 'Year',
          visible: true,
        },
        {
          text: 'Title',
          align: 'center',
          sortable: true,
          value: 'Title',
          visible: true,
        },
        {
          text: 'Is Active',
          align: 'center',
          sortable: true,
          value: 'IsActive',
          visible: this.showInactive,
        },
        {
          text: 'Session Start Date',
          align: 'center',
          sortable: true,
          value: 'SessionStartDate',
          visible: true,
        },
        {
          text: 'Session End Date',
          align: 'center',
          sortable: true,
          value: 'SessionEndDate',
          visible: true,
        },
        {
          text: 'Special Session Value',
          align: 'center',
          sortable: true,
          value: 'SpecialSessionValue',
          visible: true,
        },
        {
          text: 'Has Session Landing Page',
          align: 'center',
          sortable: true,
          value: 'HasSessionLandingPage',
          visible: true,
        },
        {
          text: 'Lso Refresh Date',
          align: 'center',
          sortable: true,
          value: 'LsoRefreshDate',
          visible: true,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: false,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    ...call('luSession', [
      'deleteLuSession',
      'loadLuSessions',
      'clearLookupCacheAndReloadLuSessions',
    ]),
  },
}
</script>
<style></style>
